module.exports = __webpack_public_path__ + "img/admin_logo_b.ffbc39c5.png";